export default __webpack_public_path__ + "static/media/FiltersIcon.117d294a.svg";